"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNestedList = exports.StyledFormListItem = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const { primaryBlueMed600 } = ui_components_1.baseColors;
exports.StyledFormListItem = styled_components_1.default.div `
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding-bottom: 0.875rem;

  .attribute-list-item-name-container {
    flex: 0 0 10rem;
    width: 10rem;
    min-width: 10rem;
  }

  .attribute-list-item-name {
    min-height: 2.875rem;
    display: flex;
    align-items: flex-start;
    padding: 0.5rem 0;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.25rem;
    color: ${primaryBlueMed600};
    white-space: pre-wrap;
  }

  .attribute-list-item-duplicate-error {
    display: block;
    margin-top: 0.25rem;
  }

  .attribute-list-item-description {
    flex: 1 1 auto;
    min-width: 0;
  }

  .attribute-list-item-textarea {
    flex: 1 1 auto;
    min-width: 0;

    &.text-field--small .MuiInputBase-root {
      align-items: flex-start;
      min-height: 2.875rem;
    }

    &.text-field--small .MuiInputBase-root input,
    &.text-field--small .MuiInputBase-root .MuiInputBase-input {
      padding: 0.5rem 0.75rem;
      height: auto;
      line-height: 1.25rem;
      overflow: auto;
      text-overflow: unset;
      white-space: pre-wrap;
    }
  }

  .attribute-list-item-action-delete {
    height: 2.875rem;
    width: 2.875rem;
  }
`;
exports.StyledNestedList = styled_components_1.default.div `
  padding-top: 0.25rem;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  flex: 1;
  min-height: 20rem;
  overflow-y: auto;

  &.attribute-list-item-nested-list--dynamic {
    flex: 0 0 auto;
    min-height: 0;
    overflow: visible;
  }
`;
